import { Alert, Box, Stack, Typography } from '@mui/material'

/**
 * Nestle Sample tab placeholder.
 *
 * Access evidence (DocConvert_Quality_overview §6.5):
 *  - Parent subform: `form_frmQualitySamplingExpSubForm.txt`
 *  - Inner subform: `form_frmQualityQrySamplingExp.txt`
 *  - Query: `QualityQrySamplingExp_all` (view `tlc_factory_view_factory_sampling3_exp2`)
 *  - Toolbar: `btnEx` caption `Export Excel( N)` (N = current visible count)
 *
 * Access uses `tmpFactory_table` as a staging table; web target nên dùng parameterized query
 * thay vì replicate shared mutable temp table.
 */
export default function NestleSampleListView() {
  return (
    <Box sx={{ py: 2 }}>
      <Stack spacing={1.5}>
        <Typography variant="subtitle1" fontWeight={700}>
          Nestle Sample
        </Typography>
        <Alert severity="info" variant="outlined">
          Tab này chưa được build chi tiết. Theo Access (`frmQualitySamplingExpSubForm`) đây là
          export-style list với button `Export Excel( N)` (N = số dòng đang hiển thị).
        </Alert>
        <Typography variant="body2" color="text.secondary">
          Tham khảo <code>DocConvert_Quality_overview.md §6.5</code> trước khi implement;
          verify schema view <code>tlc_factory_view_factory_sampling3_exp2</code>.
        </Typography>
      </Stack>
    </Box>
  )
}
